var _g, _ellipse, _ellipse2, _ellipse3, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _ellipse4, _ellipse5, _ellipse6, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductPages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 355,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#product-pages_svg__filter0_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 440,
    height: 280,
    rx: 12.279,
    fill: "url(#product-pages_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 440,
    height: 280,
    rx: 12.279,
    stroke: "#EEE",
    strokeWidth: 0.767
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.862,
    cy: 25.334,
    rx: 2.745,
    ry: 2.964,
    fill: "#ED6A5D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.011,
    cy: 25.334,
    rx: 2.745,
    ry: 2.964,
    fill: "#F4BF4F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.163,
    cy: 25.334,
    rx: 2.745,
    ry: 2.964,
    fill: "#62C755"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M274 77.535c0-.848.687-1.535 1.535-1.535h144.93c.848 0 1.535.687 1.535 1.535v21.93c0 .848-.687 1.535-1.535 1.535h-144.93A1.535 1.535 0 01274 99.465v-21.93z",
    fill: "#C4C4C4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 114,
    y: 76,
    width: 146,
    height: 138,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 68.254,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 107.395,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 146.535,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 185.676,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 116.848,
    width: 46.814,
    height: 24.863,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 154.142,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 113.535,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 167.254,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 220.977,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 274.699,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 328.418,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 382.141,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 170.717,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 187.292,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 203.867,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.087 55.023c-4.582 0-8.4 2.099-8.4 8.433 0 5.017 2.567 8.177 8.519 8.177 7.005 0 7.454-4.983 7.454-4.983h-3.394s-.728 2.683-4.267 2.683c-2.883 0-4.956-2.103-4.956-5.05h12.972v-1.85c0-2.915-1.714-7.41-7.928-7.41zm-.118 2.363c2.744 0 4.614 1.816 4.614 4.536h-9.465c0-2.888 2.442-4.535 4.851-4.535z",
    fill: "#E53238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.016 48.89v19.562c0 1.11-.074 2.67-.074 2.67h3.237s.117-1.12.117-2.144c0 0 1.6 2.703 5.948 2.703 4.58 0 7.691-3.434 7.691-8.353 0-4.577-2.857-8.258-7.683-8.258-4.52 0-5.924 2.636-5.924 2.636v-8.817h-3.313zm8.4 8.6c3.11 0 5.088 2.493 5.088 5.838 0 3.586-2.284 5.933-5.066 5.933-3.319 0-5.11-2.799-5.11-5.901 0-2.892 1.607-5.87 5.088-5.87z",
    fill: "#0064D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.98 55.023c-6.893 0-7.335 4.076-7.335 4.727h3.431s.18-2.38 3.668-2.38c2.266 0 4.023 1.12 4.023 3.275v.766h-4.023c-5.34 0-8.164 1.687-8.164 5.111 0 3.37 2.609 5.203 6.134 5.203 4.805 0 6.352-2.867 6.352-2.867 0 1.14.082 2.264.082 2.264h3.05s-.118-1.393-.118-2.284v-7.702c0-5.05-3.772-6.113-7.1-6.113zm3.787 8.688v1.022c0 1.334-.762 4.648-5.247 4.648-2.456 0-3.509-1.324-3.509-2.859 0-2.793 3.546-2.81 8.756-2.81z",
    fill: "#F5AF02"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.225 55.662h3.86l5.54 11.986 5.527-11.986h3.497L86.58 77h-3.668l2.906-5.948-7.594-15.39z",
    fill: "#86B817"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#product-pages_svg__filter1_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 88,
    width: 440,
    height: 252,
    rx: 12.279,
    fill: "url(#product-pages_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 88,
    width: 440,
    height: 252,
    rx: 12.279,
    stroke: "#EEE",
    strokeWidth: 0.767
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.815 146.29c-10.182 5.233-16.5.855-20.545-1.804-.25-.168-.676.039-.307.497 1.348 1.764 5.764 6.017 11.528 6.017 5.768 0 9.2-3.399 9.63-3.992.426-.588.125-.912-.306-.718zm2.86-1.705c-.274-.385-1.663-.456-2.538-.34-.875.112-2.19.69-2.075 1.037.058.13.178.072.78.013.603-.065 2.292-.295 2.644.202.354.501-.538 2.885-.702 3.269-.157.385.06.484.356.228.292-.256.82-.919 1.175-1.857.352-.944.567-2.259.359-2.552z",
    fill: "#F90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.971 135.613c0 1.373.032 2.518-.61 3.737-.519.991-1.34 1.601-2.258 1.601-1.253 0-1.983-1.031-1.983-2.553 0-3.003 2.492-3.548 4.851-3.548v.763zm3.291 8.59a.642.642 0 01-.77.084c-1.084-.972-1.277-1.423-1.874-2.35-1.79 1.973-3.056 2.563-5.379 2.563-2.745 0-4.883-1.829-4.883-5.492 0-2.86 1.436-4.808 3.479-5.759 1.771-.843 4.245-.992 6.136-1.225v-.456c0-.837.06-1.829-.394-2.552-.4-.65-1.162-.917-1.832-.917-1.244 0-2.354.689-2.625 2.116-.055.317-.271.63-.565.644l-3.167-.366c-.266-.065-.56-.298-.486-.739.73-4.144 4.195-5.393 7.297-5.393 1.589 0 3.663.456 4.916 1.755 1.588 1.601 1.437 3.737 1.437 6.062v5.492c0 1.65.633 2.374 1.23 3.266.211.317.257.699-.01.937-.665.6-1.849 1.715-2.5 2.34l-.01-.01",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.815 146.29c-10.182 5.233-16.5.855-20.545-1.804-.25-.168-.676.039-.307.497 1.348 1.764 5.764 6.017 11.528 6.017 5.768 0 9.2-3.399 9.63-3.992.426-.588.125-.912-.306-.718zm2.86-1.705c-.274-.385-1.663-.456-2.538-.34-.875.112-2.19.69-2.075 1.037.058.13.178.072.78.013.603-.065 2.292-.295 2.644.202.354.501-.538 2.885-.702 3.269-.157.385.06.484.356.228.292-.256.82-.919 1.175-1.857.352-.944.567-2.259.359-2.552z",
    fill: "#F90"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.12,
    cy: 100.518,
    rx: 2.745,
    ry: 2.964,
    fill: "#ED6A5D"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.269,
    cy: 100.518,
    rx: 2.745,
    ry: 2.964,
    fill: "#F4BF4F"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.421,
    cy: 100.518,
    rx: 2.745,
    ry: 2.964,
    fill: "#62C755"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 296.164,
    y: 143.423,
    width: 155.023,
    height: 24.863,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 113.512,
    y: 143.423,
    width: 151.953,
    height: 137.574,
    rx: 6.14,
    fill: "#C4C4C4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 113.512,
    y: 290.942,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 152.652,
    y: 290.942,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 191.793,
    y: 290.942,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 230.934,
    y: 290.942,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 296.164,
    y: 184.032,
    width: 46.814,
    height: 24.863,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 296.164,
    y: 221.326,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 113.512,
    y: 125.19,
    width: 64.465,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 296.164,
    y: 237.901,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 296.164,
    y: 254.477,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 296.164,
    y: 271.052,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "product-pages_svg__paint0_linear",
    x1: 233,
    y1: 12,
    x2: 233,
    y2: 292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "product-pages_svg__paint1_linear",
    x1: 278,
    y1: 88,
    x2: 278,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "product-pages_svg__filter0_di",
    x: 0.337,
    y: 0.872,
    width: 465.326,
    height: 305.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.535
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.678431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.535,
    dy: 2.302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "product-pages_svg__filter1_di",
    x: 45.337,
    y: 76.872,
    width: 465.326,
    height: 277.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.535
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.678431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.535,
    dy: 2.302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })))));
}

export default __webpack_public_path__ + "static/product-pages.8b354ac4.svg";
export { SvgProductPages as ReactComponent };